import { VRAsset } from './asset.js';
import { VRSign } from './sign.js';

export class VRTable extends VRAsset {
  constructor (vr, scene, options) {
    super(vr, scene, options);

    this.scene = scene;

    this.div.addClass('ca-vr_overlay ca-vr_overlay_table');

    const coords = [
      [
        [64.60015455268483, -19.5332200470684],
        [83.39058994303598, -22.99506787437957],
        [65.65861710516597, -35.84395076366172],
        [44.26827454410503, -25.141432292405923]
      ],
      [
        [83.39058994303598, -22.99506787437957],
        [108.61612637685349, -24.272745726571458],
        [113.12844001624153, -42.562538639213145],
        [65.65861710516597, -35.84395076366172]
      ],
      [
        [108.61612637685349, -24.272745726571458],
        [132.3349437935296, -21.91885544793829],
        // eslint-disable-next-line no-loss-of-precision
        [152.53137522326506, -32.115097139107203],
        [113.12844001624153, -42.562538639213145]
      ],
      [
        [132.3349437935296, -21.91885544793829],
        [149.59396660802216, -18.100893014586475],
        [169.49441595684283, -22.253705113448614],
        // eslint-disable-next-line no-loss-of-precision
        [152.53137522326506, -32.115097139107203]
      ]
    ];

    this.tableTopParts = [];

    for (let i = 0; i < 4; i++) {
      const top = new VRSign(this.vr, this.scene, {
        coords: coords[i],
        id: 'overlay_tabletophalf_' + i,
        type: 'sign'
      });

      top.div.addClass('ca-vr_overlay_tabletophalf');
      top.div.addClass(top.options.id);
      this.div.append(top.div);

      top.assetContainer.append(
        '<div class="ca-vr_overlay_tabletophalf_shadow"></div>'
      );
      top.assetContainer.append(
        '<div class="ca-vr_overlay_tabletophalf_glass"></div>'
      );
      top.assetContainer.append(
        '<div class="ca-vr_overlay_tabletophalf_frame ca-vr_overlay_tabletophalf_topframe"></div>'
      );
      top.assetContainer.append(
        '<div class="ca-vr_overlay_tabletophalf_frame ca-vr_overlay_tabletophalf_leftframe"></div>'
      );
      top.assetContainer.append(
        '<div class="ca-vr_overlay_tabletophalf_frame ca-vr_overlay_tabletophalf_rightframe"></div>'
      );
      top.assetContainer.append(
        '<div class="ca-vr_overlay_tabletophalf_frame ca-vr_overlay_tabletophalf_bottomframe"></div>'
      );

      this.createLegs(i, top);

      this.tableTopParts.push(top);
    }
  }

  createLegs (i, top) {
    if (i === 0) {
      top.assetContainer.append(
        '<svg class="ca-vr_overlay_tabletophalf_edge"><path class="ca-vr_overlay_table_leftleg_inner" d="M504,0 L1218,2 L1244,79 L811,80 L1215,291 L1217,300" /><path class="ca-vr_overlay_table_leftleg" d="M500,0 L1200,2 L1193,79 L776,80 L1219,302 L1202,302" /><path class="ca-vr_overlay_table_edge" d="M 100,0 L1172,0 L1172,18 L160,20" /></svg>'
      );
    } else if (i === 3) {
      top.assetContainer.append(
        '<svg class="ca-vr_overlay_tabletophalf_edge"><path class="ca-vr_overlay_table_rightleg_inner" fill="#232121" d="M 763,0 L670,50 L17,310 L19,301" /><path class="ca-vr_overlay_table_rightleg" d="M 2,0 L899,2 L36,311 L15,311 L600,78 L00,79" /><path class="ca-vr_overlay_table_edge" d="M 0,0 L1272,2 L1217,20 L00,20" /></svg>'
      );
    } else {
      top.assetContainer.append(
        '<svg class="ca-vr_overlay_tabletophalf_edge"><path class="ca-vr_overlay_table_frame" d="M0,3 L1500,3 L1500,78 L0,80 L0,80" /><path class="ca-vr_overlay_table_edge" d="M 0,0 L1172,0 L1172,20 L00,20" /></svg>'
      );
    }
  }

  render (t) {
    this.tableTopParts.forEach((p) => p.render(t));
  }

  onToggleDayNight () {}

  getDistance () {
    return 0;
  }

  getJsonConfig () {
    const config = Object.assign({}, this.options);
    return config;
  }
}
